
// ==== MOBILE MENU



var mobileMenu = {
    // transition events
    transEndEventNames: {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'msTransition': 'MSTransitionEnd',
        'transition': 'transitionend'
    },

    show: function() {
        var _this = this;
        _this.overlay.addClass( 'on' );
        _this.body.addClass( 'menu-on' );
        _this.triggerBtn.addClass( 'off' );

        // disable body overflow without making the page jump
        // var scrollbarWidth = getScrollBarWidth();
        // if ( scrollbarWidth ) {
        //     _this.body.css( 'padding-right', scrollbarWidth );
        // }

        _this.body.addClass( 'no-scroll' );
    },

    hide: function() {
        var _this = this;
        _this.overlay.removeClass('on').addClass('off');
        _this.body.removeClass('menu-on').addClass('menu-off');
        _this.triggerBtn.removeClass('off' ).addClass('on' );

        _this.body.removeClass( 'no-scroll' );
        _this.body.css( 'padding-right', '0' );

        // update classes once transition finished
        _this.overlay.on(_this.transEndEventName, function() {
            _this.overlay.removeClass( 'off' );
            _this.body.removeClass( 'menu-off' );
            _this.triggerBtn.removeClass( 'on' );
        })
    },

    handleToggle: function() {
        var _this = this;
        if( _this.overlay.hasClass('on') ) {
            _this.hide();
        }
        else if( !_this.overlay.hasClass( 'off' ) ) {
            $('body,html').stop().animate({
                'scrollTop': 0
            }, 200);
            _this.show();
        } 
    },

    init: function() {
        var _this = this;

        _this.body = $('body');
        _this.triggerBtn = $( '.trigger-mobile-menu' );
        _this.overlay = $( '#nav' );
        _this.header = $('#header');

        _this.transEndEventName = _this.transEndEventNames[ Modernizr.prefixed( 'transition' ) ];

        // Toggle mobile menu - clear any previous click handlers
        _this.triggerBtn.off('click').on('click', function(){
            _this.handleToggle();
        } );

        // Click on overlay: close manu
        $('#mobile-menu-overlay').off('click').on('click', function(){
            _this.handleToggle();
        } );

        // on resize, close mobile menu on bigger screens
        $(window).smartresize(function () { 
            if ( $(window).width() > 767 && _this.body.hasClass( 'menu-on' ) ) {
                _this.overlay.removeClass( 'on' );
                _this.body.removeClass( 'menu-on' );
                _this.triggerBtn.removeClass( 'off' );
            }
        })
    },

    destroy: function() {
        var _this = this;
        _this.overlay.removeClass( 'on' );
        _this.body.removeClass( 'menu-on' );
        _this.triggerBtn.removeClass( 'off' );
    }
}








